import React, { useEffect, useState } from "react";
import { Typography, Box, Button } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { constants, environmentVariables } from "../../../../Shared/Url/Constants";
import { useSelector } from "react-redux";
import Cookie from "js-cookie";
import { IsTokenValid } from "../../../../Shared/Utill/AuthUtil";

const DeleteEventDialog = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const urlDetails = useSelector((state) => state.url.urlData);
    const token = Cookie.get('X_TKN');

    useEffect(() => {
        dialog.show();
    }, []);

    const deleteEventAction = () => {
        // call delet event  api
        console.log("request payload",props.data)
        callDeleteService(props.divNbr,props.locNbr,props.pwhGrpNbr);
       
    }

    const callDeleteService = (divnbr,locnbr,prefgrpnbr) =>{
        let data = {
            divNbr:divnbr,
            locNbr:locnbr,
            pwhGrpNbr:prefgrpnbr
        }
       
       axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_PREFERENCE_GROUPS_ADMIN_DELETE}`,
       data, 
       {
            headers: {
            'content-type': 'application/json',
            'Authorization': 'Bearer ' + token
            }
        })
        .then((response) => {
         console.log("response is",response.data);
         if(response.status === 200){
          // success close popup
             props.onDeleteCallback("success","Division " + {divnbr} +" Location" + {locnbr});   
         }else{
            props.onDeleteCallback("error","Something went wrong"); 
         }
        })
        .catch((error) => {
           //catch
         props.onDeleteCallback("error",error.response.data.message); 
        })
    }
  
    
    const closeDialog = () => {
        dialog.hide();
        props.onCloseDialog(); 
    }
    return (
        <Box>
            <Dialog
                open={dialog.open}
                title={"Confirm Delete Event"}
                onClose={closeDialog}
                actions={
                    <>
                        <Button color="secondary" onClick={() => closeDialog()}>No</Button>
                        <Button onClick={() => deleteEventAction()}>Yes</Button>
                    </>
                }
            >
                <Typography>{"Deleting this event will also delete all the included locations, controls and colleague responses."}</Typography>
            </Dialog>
        </Box>
    );
}

export default DeleteEventDialog;

